import { columnOnePath, documentOnePath } from '@/utils/router/links';
/**
 * コラム一覧データを共通フォーマットに整形して返す
 */
export const parseColumnListData = (columnListData) => {
    // データがない場合 null を返す
    if (!columnListData)
        return null;
    const { list, pagination } = columnListData;
    // list を共通フォーマットに整形
    const parsedList = list.map((column) => ({
        dataType: column.data_type,
        displayFromAt: column.display_from_at,
        id: column.url_code,
        isLimit: column.is_limit,
        themes: column.themes,
        thumbnailPicture: column.thumbnail_picture,
        title: column.title,
        to: columnOnePath(column.weight_level, column.url_code),
        weightLevel: column.weight_level,
    }));
    return {
        currentPage: pagination.current_page,
        lastPage: pagination.total_page,
        list: parsedList,
    };
};
/**
 * ダウンロード資料一覧データを共通フォーマットに整形して返す
 */
export const parseDocumentListData = (documentListData) => {
    // データがない場合 null を返す
    if (!documentListData)
        return null;
    const { list, pagination } = documentListData;
    // list を共通フォーマットに整形
    const parsedList = list.map((document) => ({
        displayFromAt: document.display_from_at,
        fileExtension: document.file_extension,
        id: document.id,
        isLimit: document.is_limit,
        themes: document.themes,
        thumbnailPicture: document.thumbnail_picture,
        title: document.title,
        to: documentOnePath(document.weight_level, document.id),
        weightLevel: document.weight_level,
    }));
    return {
        currentPage: pagination.current_page,
        lastPage: pagination.total_page,
        list: parsedList,
    };
};
